(function () {
  var bar = document.getElementById('PgStickyAtc');
  if (!bar) return;

  var mainForm = document.querySelector('form[action*="/cart/add"]');
  if (!mainForm) return;

  var mainBtn   = mainForm.querySelector('[name="add"], button[type="submit"]');
  var idInput   = mainForm.querySelector('input[name="id"], select[name="id"]');
  var stickyBtn = document.getElementById('PgStickyBtn');
  var priceEl   = document.getElementById('PgStickyPrice');
  var compareEl = document.getElementById('PgStickyCompare');

  var variants = [];
  try { variants = JSON.parse(bar.dataset.variants || '[]'); } catch (e) {}

  var soldOutText = document.documentElement.lang === 'ar' ? 'غير متوفر' : 'Sold out';
  var addText     = stickyBtn.textContent.trim();

  /* ---- money formatting (EGP, no decimals) ---- */
  function money(cents) {
    var n = Math.round(cents / 100);
    return n.toLocaleString() + ' EGP';
  }

  /* ---- sync price + availability from current variant ---- */
  function sync() {
    if (!idInput) return;
    var v = variants.find(function (x) { return String(x.id) === String(idInput.value); });
    if (!v) return;
    priceEl.textContent = money(v.price);
    if (v.compare_at_price && v.compare_at_price > v.price) {
      compareEl.textContent = money(v.compare_at_price);
      compareEl.hidden = false;
    } else {
      compareEl.hidden = true;
    }
    if (v.available === false) {
      stickyBtn.disabled = true;  stickyBtn.textContent = soldOutText;
    } else {
      stickyBtn.disabled = false; stickyBtn.textContent = addText;
    }
  }

  /* Dawn swaps the hidden id input on variant change; watch both events + attribute */
  mainForm.addEventListener('change', function () { setTimeout(sync, 50); });
  document.addEventListener('change', function (e) {
    if (e.target.closest('variant-radios, variant-selects, variant-picker')) setTimeout(sync, 80);
  });
  new MutationObserver(function(){ sync(); })
    .observe(idInput, { attributes: true, attributeFilter: ['value'] });
  sync();

  /* ---- show bar only when the real ATC button is off-screen ---- */
  var target = mainBtn || mainForm;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var pastIt = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', pastIt);
      bar.setAttribute('aria-hidden', pastIt ? 'false' : 'true');
    }, { threshold: 0 }).observe(target);
  } else {
    bar.classList.add('is-visible'); // ancient browser fallback
  }

  /* ---- delegate the click to the real button ---- */
  stickyBtn.addEventListener('click', function () {
    if (stickyBtn.disabled) return;
    stickyBtn.classList.add('is-adding');
    if (mainBtn) mainBtn.click(); else mainForm.requestSubmit();
    setTimeout(function () { stickyBtn.classList.remove('is-adding'); }, 1500);
  });
})();